import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import CoachCollection from 'collections/coach_list';
import ContactCollection from 'collections/contact';
import DomainCollection from 'collections/domains';


export default Backbone.View.extend({
  events: {
    click: 'open_detail'
  },
  initialize: function (options) {
    _.bindAll(this, 'render', 'open_detail', 'highlight', 'unhighlight',
      'user_status_changed');

    this.template = _.template($('#contact-tmpl').html());
    this.coachhub = options.coachhub;
    this.coach_detail_view = this.coachhub.coach_detail_view;

    this.render();

    this.coach_detail_view.on('closed', this.unhighlight);
    this.coach_detail_view.on('changed_model', this.highlight);
    this.coachhub.on('user-online user-offline', this.user_status_changed);
  },

  render: function () {
    this.$el.html(this.template({ contact: this.model }));
    if (this.coach_detail_view.model && this.coach_detail_view.model.id == this.model.id) {
      this.highlight(this.model.get('user').id);
    }
  },

  user_status_changed: function (data) {
    // A user's status changed. If the user is me,
    // fetch the latest information and rerender
    if (this.model.get('user').url != data.user) {
      return;
    }
    this.model.fetch({ success: this.render });
  },

  open_detail: function (e) {
    var coach = this.coachhub.coaches.get_coach_by_user_id(this.model.get('user').id);
    this.coachhub.coach_detail_view.set_coach(coach, { nav: 'messages', is_contact: true });
  },

  highlight: function (user_id) {
    if (this.model.get('user').id == user_id) {
      this.$el.addClass('highlight');
    } else {
      this.unhighlight();
    }
  },

  unhighlight: function () {
    this.$el.removeClass('highlight');
  }
});



// WEBPACK FOOTER //
// ./static/js/views/contact.js